var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPreqin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M5.377 11.092H4v3.63h.71v-1.087h.667c.71 0 1.22-.53 1.22-1.271s-.51-1.272-1.22-1.272m0 1.804H4.71v-1.064h.667c.332 0 .51.208.51.531 0 .325-.178.533-.51.533M10.504 14.722h2.24v-.716h-1.553v-.74h1.553v-.718h-1.553v-.716h1.553v-.74h-2.24zM17.38 11.088h.71v3.626h-.71zM21.312 11.092v2.382l-1.887-2.382h-.6v3.63h.689V12.34l1.886 2.382h.6v-3.63zM16.784 12.897c0-1.041-.821-1.897-1.82-1.897-.998 0-1.797.856-1.797 1.897 0 1.016.799 1.872 1.797 1.872.333 0 .622-.092.888-.23l.465.461.49-.508-.423-.439c.245-.302.4-.717.4-1.156m-1.82 1.133c-.6 0-1.087-.51-1.087-1.133 0-.648.488-1.156 1.087-1.156s1.11.508 1.11 1.156a1.3 1.3 0 0 1-.2.646l-.466-.484-.488.508.399.394a.9.9 0 0 1-.355.069M9.838 12.364c0-.74-.511-1.272-1.244-1.272H7.086v3.63h.688v-1.087h.82l.644 1.087h.821l-.777-1.295c.334-.207.556-.6.556-1.063m-.733.184c0 .023 0 .023-.022.046-.022.048-.045.117-.089.164-.022.023-.066.046-.088.069a.6.6 0 0 1-.312.07h-.8200000000000001v-1.065h.82c.356 0 .533.208.533.531 0 .07 0 .14-.022.185"
  })));
};
export default SvgPreqin;